import React from 'react';
import { Container, Box } from '@material-ui/core';
import Bar from "./Bar";
import Grid from "./Grid";

function App() {
  return (
  <Container maxWidth={false} >
    <Bar/>
    <Box mt={1}>
      <Grid / >
    </Box>
  </Container>
)}

export default App;
